import styled from "styled-components";

export const StyledNotificationPanel = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 20px 20px 20px;
  gap: 20px;
  box-sizing: border-box;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: hidden;

  & .notification-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  & .empty-notifications {
    display: flex;
    justify-content: center;
    margin-top: 24px;
  }
`;

export const StyledNotificationList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

export const StyledNotificationHeader = styled.div`
  .filters-container {
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 15px;
  }
`;
